import React from 'react';
import {
  SelectDividerProps,
  SelectOptionGroupProps,
  SelectOptionProps,
  SelectProps,
} from './Select.typed';
import * as Styled from './Select.styled';

const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  (props: SelectProps, ref) => {
    const { hasError = false, children, ...rest } = props;

    return (
      <Styled.Wrapper>
        <Styled.Select ref={ref} hasError={hasError} {...rest}>
          {children}
        </Styled.Select>
        <Styled.Icon name="ChevronDownOutline" size="s" />
      </Styled.Wrapper>
    );
  },
);

const Option = (props: SelectOptionProps) => <option {...props} />;

// &#9472; is a special character for creating a divider. Looks better than multiple `-`
const Divider = (props: SelectDividerProps) => (
  <option
    disabled
    value=""
    aria-hidden={true}
    dangerouslySetInnerHTML={{ __html: `&#9472;`.repeat(props.width ?? 10) }}
  ></option>
);

const OptionGroup = (props: SelectOptionGroupProps) => <optgroup {...props} />;

export default Object.assign(Select, {
  Option,
  OptionGroup,
  Divider,
});
